import {createBrowserRouter} from "react-router-dom";

import Layout from "../_Layout"
import ErrorPage from "../pages/404";

import Home from "../pages/home";
import MentionsLegales from "../pages/mentions-legales";
import Faq from "../pages/faq";
import OperationTerminee from "../pages/operation-terminee";

import {isOpeStartRedirect, isOpeStopRedirect} from "../loader/redirectLoader";

import ProtectedRoute from "./ProtectedRoute";

import Connexion from "../pages/compte/Connexion";
import Inscription from "../pages/compte/Inscription";
import Chemin from "../pages/compte/Chemin";
import LostPassword from "../pages/compte/LostPassword";
import LogOffRoute from "./logOffRoute";
import Dotation from "../pages/dotation";
import Contact from "../pages/contact";
import InstantGagnant from "../pages/compte/InstantGagnant";
import MonCompte from "../pages/compte/MonCompte";
import Prochainement from "../pages/Prochainement";


const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout/>,
        errorElement: <ErrorPage />,
        children : [
            {
                path: "/",
                element : <Home/>,
                loader : isOpeStartRedirect
            },
            {
                path : "/informations-legales",
                element : <MentionsLegales/>,
                loader : isOpeStartRedirect
            },
            {
                path : "/faq",
                element : <Faq/>,
                loader : isOpeStartRedirect
            },
            {
                path : "/contact",
                element : <Contact/>,
                loader : isOpeStartRedirect
            },
            {
                path : "/operation-terminee",
                element : <OperationTerminee/>,
                loader : isOpeStartRedirect
            },
            {
                path : "/les-cadeaux",
                element : <Dotation/>,
            },
            {
                path : "/prochainement",
                element : <ProtectedRoute><Prochainement/></ProtectedRoute>,
            },
            //--------------------------
            //  COMPTE
            //--------------------------
            {
                path : "/connexion",
                element : <LogOffRoute><Connexion/></LogOffRoute>,
                loader : isOpeStopRedirect
            },
            {
                path : "/inscription",
                element : <LogOffRoute><Inscription/></LogOffRoute>,
                loader : isOpeStopRedirect
            },
            {
                path : "/mes-cartes",
                element : <ProtectedRoute><Chemin/></ProtectedRoute>,
                loader : isOpeStopRedirect
            },
            {
                path : "/mon-compte",
                element : <ProtectedRoute><MonCompte/></ProtectedRoute>,
                loader : isOpeStopRedirect
            },
            {
                path : "/instant-gagnant/:code_unique",
                element : <ProtectedRoute><InstantGagnant/></ProtectedRoute>,
                loader : isOpeStopRedirect
            },
            {
                path : "/mot-de-passe-oublie",
                element : <LogOffRoute><LostPassword/></LogOffRoute>,
                loader : isOpeStopRedirect
            }
        ]
    },
]);

export default router